import React from 'react';
import { Pie } from 'react-chartjs-2';
import { pieOptions } from './config';

const PieComponent = ({ data }) => {
  return (
    <Pie data={data} options={pieOptions} />
  );
}

export default PieComponent;